"use client";

import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const flowSteps = [{
  id: "movement",
  title: "Movement",
  description: "Awaken the body. High-energy vinyasa meets deep bass.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/ritual_flow_movement.png"
}, {
  id: "music",
  title: "Music",
  description: "126 BPM driving groove. The heartbeat of the night.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/ritual_flow_music.png"
}, {
  id: "ritual",
  title: "Ritual",
  description: "Sacred space. Intention setting and collective presence.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/ritual_flow_ritual.png"
}, {
  id: "dining",
  title: "Dining",
  description: "Nourish together. Curated exotic flavors and connection.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/ritual_flow_dining.png"
}];
export default function TheRitualFlow() {
  return;
}